import { MouseEvent } from 'react';

import { Button } from 'antd';
import cs from 'classnames';

import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import { ReactComponent as TickCircleIcon } from 'assets/icons/tick-circle.svg';

import styles from './ActionButton.module.scss';

interface ActionButtonProps {
  title: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  isCompleted: boolean;
}

const ActionButton = ({ title, onClick, isCompleted }: ActionButtonProps) => {
  return (
    <Button
      type="primary"
      className={cs(styles.button, {
        [styles.inactive]: !isCompleted,
        [styles.active]: isCompleted
      })}
      icon={
        <div
          className={cs(styles.iconWrapper, {
            [styles.inactive]: !isCompleted,
            [styles.active]: isCompleted
          })}
        >
          <ArrowRightIcon />
        </div>
      }
      iconPosition="end"
      onClick={onClick}
      title=""
    >
      <div className={styles.contentWrapper}>
        {isCompleted && (
          <div className={cs(styles.iconWrapper, styles.active)}>
            <TickCircleIcon />
          </div>
        )}
        <div className={styles.title}>{title}</div>
      </div>
    </Button>
  );
};

export default ActionButton;
